import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ILessonFilterOption, ILessonListItem } from '@lb/api/mylb/interfaces';
import { NotificationBaseComponent } from './notification-base/notification-base.component';
import { MDTagComponent } from '@melodic-ui/components';
import { take } from 'rxjs';
import { RescheduleLessonDialogService } from '@lb/services/reschedule-lesson-dialog.service';
import { LessonV2Service } from '@lb/api/mylb/services';
import { LessonStateService } from '@lb/state/lesson-state.service';
import { TzDatePipe } from '@lb/pipes/timezone-aware-date.pipe';

@Component({
	standalone: true,
	imports: [CommonModule, RouterModule, NotificationBaseComponent, MDTagComponent, TzDatePipe],
	selector: 'lb-notification-rescheduled',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			Has proposed to reschedule the <b>{{ lesson()?.originalLessonDate | tzDate: 'MMM d' }}</b> lesson.
		</div>
		<div activity-action class="flex-actions">
			@if (lesson()?.makeUp) {
				<md-tag>Makeup Lesson</md-tag>
			}
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationRescheduleProposalComponent extends NotificationBaseComponent implements OnInit {
	private _rescheduleLessonDialogService = inject(RescheduleLessonDialogService);
	private _lessonService = inject(LessonV2Service);
	private _lessonStateService = inject(LessonStateService);
	lesson = signal<ILessonListItem | null>(null);

	ngOnInit(): void {
		const lessonID = this.notification().entityID;
		const filterOptions: ILessonFilterOption = { lessonIDs: [lessonID], page: 1, pageSize: 1 };

		this._lessonService
			.getLessons(filterOptions)
			.pipe(take(1))
			.subscribe({
				next: (response) => {
					this.lesson.set(response.items[0] ?? null);
				}
			});
	}

	reschedule(): void {
		const lesson = this.lesson();
		if (!lesson) {
			return;
		}

		this._rescheduleLessonDialogService
			.open(lesson, 'learner')
			.pipe(take(1))
			.subscribe((newLessonHistory) => {
				if (newLessonHistory) {
					this.reloadNotifications();
					this._lessonStateService.notifyLessonChanged();
				}
			});
	}
}
